import * as React from 'react'

import { PlayState } from '@envato/react-video'

import FullscreenExitIcon from '../../icons/fullscreenExit'
import MutedIcon from '../../icons/muted'
import PauseIcon from '../../icons/pauseIsolated'
import PlayIcon from '../../icons/playIsolated'
import UnmutedIcon from '../../icons/unmuted'

import * as styles from './videoControlsFullscreen.module.css'

interface IProps {
  playState: PlayState
  onPause: () => any
  onPlay: () => any
  onExitFullscreen: () => any
  onMouseMove: () => any
  muted: boolean
  onMuteVideo: () => any
  onUnmuteVideo: () => any
  includeMuteUnmute?: boolean
}

const { PLAY, PAUSE } = PlayState

class VideoControlsFullscreen extends React.Component<IProps> {
  public render() {
    const {
      playState,
      onPlay,
      onPause,
      onExitFullscreen,
      onMouseMove,
      muted,
      onMuteVideo,
      onUnmuteVideo,
      includeMuteUnmute
    } = this.props

    return (
      <div role="button" className={styles.root} onMouseMove={onMouseMove}>
        {playState === PLAY && (
          <button onClick={onPause} className={styles.control}>
            <PauseIcon className={styles.icon} />
          </button>
        )}
        {playState === PAUSE && (
          <button onClick={onPlay} className={styles.control}>
            <PlayIcon className={styles.icon} />
          </button>
        )}

        <div>
          {includeMuteUnmute && (
            <button
              className={styles.control}
              onClick={muted ? onUnmuteVideo : onMuteVideo}
            >
              {muted && <MutedIcon className={styles.icon} />}
              {!muted && <UnmutedIcon className={styles.icon} />}
            </button>
          )}

          <button className={styles.control} onClick={onExitFullscreen}>
            <FullscreenExitIcon className={styles.icon} />
          </button>
        </div>
      </div>
    )
  }
}

export default VideoControlsFullscreen
